import { Nullable } from '@/utils/types';
import { IBrokerFilter } from '@/bundles/GroupFilters/interfaces/IBrokerFilter';
import { IGroupFilters } from '@/bundles/GroupFilters/helpers/getDefaultFiltersObj';
import { mapNewFiltersWithAdditionalKeysForApi } from '@/bundles/GroupFilters/helpers/mapNewFiltersWithAdditionalKeysForApi';

type FilterType = Nullable<string | number> | IBrokerFilter;
type FormattedFilterType = Nullable<string | number>;

const formatObjValue = (value: FilterType[]): FormattedFilterType[] => {
  return value.map((item) => {
    if (typeof item === 'object' && item !== null) {
      return item.id;
    }

    return item;
  });
};

export const getFormattedGroupFiltersArray = (filters: IGroupFilters): Array<Record<string, any>> => {
  return Object.entries(filters).map(([groupId, group]) => {
    const formattedGroup: Record<string, any> = {};

    Object.entries(group).forEach(([filterKey, filterItem]) => {
      if (Array.isArray(filterItem.value)) { // in some cases, we store objects inside an array, so we need to map them
        formattedGroup[filterKey] = formatObjValue(filterItem.value);
      } else if (filterKey === 'focus_area') { // value is { member_id, member_name } — API expects just the member id
        formattedGroup[filterKey] = filterItem.value?.member_id ?? null;
      } else if (typeof filterItem.value === 'object' && filterItem.value !== null) { // some filters store a single { id, name } object
        formattedGroup[filterKey] = filterItem.value.id;
      } else {
        formattedGroup[filterKey] = filterItem.value;
      }
    });

    return mapNewFiltersWithAdditionalKeysForApi(formattedGroup, groupId, filters);
  });
};
